export const NON_EU_COUNTRIES: { value: string; isPostCodeRequired: boolean }[] = [
  { value: 'ad', isPostCodeRequired: true },
  { value: 'ae', isPostCodeRequired: false },
  { value: 'af', isPostCodeRequired: true },
  { value: 'ag', isPostCodeRequired: false },
  { value: 'ai', isPostCodeRequired: true },
  { value: 'al', isPostCodeRequired: true },
  { value: 'am', isPostCodeRequired: true },
  { value: 'ao', isPostCodeRequired: false },
  { value: 'aq', isPostCodeRequired: false },
  { value: 'ar', isPostCodeRequired: true },
  { value: 'as', isPostCodeRequired: true },
  { value: 'au', isPostCodeRequired: true },
  { value: 'aw', isPostCodeRequired: false },
  { value: 'az', isPostCodeRequired: true },
  { value: 'ba', isPostCodeRequired: true },
  { value: 'bb', isPostCodeRequired: true },
  { value: 'bd', isPostCodeRequired: true },
  { value: 'bf', isPostCodeRequired: false },
  { value: 'bh', isPostCodeRequired: true },
  { value: 'bi', isPostCodeRequired: false },
  { value: 'bj', isPostCodeRequired: false },
  { value: 'bl', isPostCodeRequired: true },
  { value: 'bm', isPostCodeRequired: true },
  { value: 'bn', isPostCodeRequired: true },
  { value: 'bo', isPostCodeRequired: false },
  { value: 'bq', isPostCodeRequired: false },
  { value: 'br', isPostCodeRequired: true },
  { value: 'bs', isPostCodeRequired: false },
  { value: 'bt', isPostCodeRequired: true },
  { value: 'bv', isPostCodeRequired: false },
  { value: 'bw', isPostCodeRequired: false },
  { value: 'by', isPostCodeRequired: true },
  { value: 'bz', isPostCodeRequired: false },
  { value: 'ca', isPostCodeRequired: true },
  { value: 'cc', isPostCodeRequired: true },
  { value: 'cd', isPostCodeRequired: true },
  { value: 'cf', isPostCodeRequired: false },
  { value: 'cg', isPostCodeRequired: false },
  { value: 'ci', isPostCodeRequired: false },
  { value: 'ck', isPostCodeRequired: false },
  { value: 'cl', isPostCodeRequired: true },
  { value: 'cm', isPostCodeRequired: false },
  { value: 'cn', isPostCodeRequired: true },
  { value: 'co', isPostCodeRequired: true },
  { value: 'cr', isPostCodeRequired: true },
  { value: 'cu', isPostCodeRequired: true },
  { value: 'cv', isPostCodeRequired: true },
  { value: 'cw', isPostCodeRequired: false },
  { value: 'cx', isPostCodeRequired: true },
  { value: 'dj', isPostCodeRequired: true },
  { value: 'dm', isPostCodeRequired: false },
  { value: 'do', isPostCodeRequired: true },
  { value: 'dz', isPostCodeRequired: true },
  { value: 'ec', isPostCodeRequired: true },
  { value: 'eg', isPostCodeRequired: true },
  { value: 'eh', isPostCodeRequired: true },
  { value: 'er', isPostCodeRequired: false },
  { value: 'et', isPostCodeRequired: true },
  { value: 'fj', isPostCodeRequired: false },
  { value: 'fk', isPostCodeRequired: true },
  { value: 'fm', isPostCodeRequired: true },
  { value: 'fo', isPostCodeRequired: true },
  { value: 'ga', isPostCodeRequired: false },
  { value: 'gb', isPostCodeRequired: true },
  { value: 'gd', isPostCodeRequired: false },
  { value: 'ge', isPostCodeRequired: true },
  { value: 'gg', isPostCodeRequired: true },
  { value: 'gh', isPostCodeRequired: true },
  { value: 'gi', isPostCodeRequired: true },
  { value: 'gl', isPostCodeRequired: true },
  { value: 'gm', isPostCodeRequired: false },
  { value: 'gn', isPostCodeRequired: true },
  { value: 'gq', isPostCodeRequired: false },
  { value: 'gs', isPostCodeRequired: true },
  { value: 'gt', isPostCodeRequired: true },
  { value: 'gu', isPostCodeRequired: true },
  { value: 'gw', isPostCodeRequired: true },
  { value: 'gy', isPostCodeRequired: false },
  { value: 'hk', isPostCodeRequired: true },
  { value: 'hm', isPostCodeRequired: true },
  { value: 'hn', isPostCodeRequired: true },
  { value: 'ht', isPostCodeRequired: true },
  { value: 'id', isPostCodeRequired: true },
  { value: 'il', isPostCodeRequired: true },
  { value: 'im', isPostCodeRequired: true },
  { value: 'in', isPostCodeRequired: true },
  { value: 'io', isPostCodeRequired: true },
  { value: 'iq', isPostCodeRequired: true },
  { value: 'ir', isPostCodeRequired: true },
  { value: 'je', isPostCodeRequired: true },
  { value: 'jm', isPostCodeRequired: false },
  { value: 'jo', isPostCodeRequired: true },
  { value: 'jp', isPostCodeRequired: true },
  { value: 'ke', isPostCodeRequired: true },
  { value: 'kg', isPostCodeRequired: true },
  { value: 'kh', isPostCodeRequired: true },
  { value: 'ki', isPostCodeRequired: true },
  { value: 'km', isPostCodeRequired: false },
  { value: 'kn', isPostCodeRequired: true },
  { value: 'kp', isPostCodeRequired: true },
  { value: 'kr', isPostCodeRequired: false },
  { value: 'kw', isPostCodeRequired: true },
  { value: 'ky', isPostCodeRequired: true },
  { value: 'kz', isPostCodeRequired: true },
  { value: 'la', isPostCodeRequired: true },
  { value: 'lb', isPostCodeRequired: true },
  { value: 'lc', isPostCodeRequired: true },
  { value: 'lk', isPostCodeRequired: true },
  { value: 'lr', isPostCodeRequired: true },
  { value: 'ls', isPostCodeRequired: true },
  { value: 'ly', isPostCodeRequired: false },
  { value: 'ma', isPostCodeRequired: true },
  { value: 'md', isPostCodeRequired: true },
  { value: 'me', isPostCodeRequired: true },
  { value: 'mg', isPostCodeRequired: true },
  { value: 'mh', isPostCodeRequired: true },
  { value: 'mk', isPostCodeRequired: true },
  { value: 'ml', isPostCodeRequired: false },
  { value: 'mm', isPostCodeRequired: true },
  { value: 'mn', isPostCodeRequired: true },
  { value: 'mo', isPostCodeRequired: true },
  { value: 'mp', isPostCodeRequired: true },
  { value: 'mr', isPostCodeRequired: false },
  { value: 'ms', isPostCodeRequired: true },
  { value: 'mu', isPostCodeRequired: true },
  { value: 'mv', isPostCodeRequired: true },
  { value: 'mw', isPostCodeRequired: true },
  { value: 'mx', isPostCodeRequired: true },
  { value: 'my', isPostCodeRequired: true },
  { value: 'mz', isPostCodeRequired: true },
  { value: 'na', isPostCodeRequired: true },
  { value: 'nc', isPostCodeRequired: true },
  { value: 'ne', isPostCodeRequired: true },
  { value: 'nf', isPostCodeRequired: true },
  { value: 'ng', isPostCodeRequired: true },
  { value: 'ni', isPostCodeRequired: true },
  { value: 'np', isPostCodeRequired: true },
  { value: 'nr', isPostCodeRequired: true },
  { value: 'nu', isPostCodeRequired: true },
  { value: 'nz', isPostCodeRequired: true },
  { value: 'om', isPostCodeRequired: true },
  { value: 'pa', isPostCodeRequired: true },
  { value: 'pe', isPostCodeRequired: true },
  { value: 'pf', isPostCodeRequired: true },
  { value: 'pg', isPostCodeRequired: true },
  { value: 'ph', isPostCodeRequired: true },
  { value: 'pk', isPostCodeRequired: true },
  { value: 'pm', isPostCodeRequired: true },
  { value: 'pn', isPostCodeRequired: true },
  { value: 'pr', isPostCodeRequired: true },
  { value: 'ps', isPostCodeRequired: true },
  { value: 'pw', isPostCodeRequired: true },
  { value: 'py', isPostCodeRequired: true },
  { value: 'qa', isPostCodeRequired: false },
  { value: 'qp', isPostCodeRequired: true },
  { value: 'rs', isPostCodeRequired: true },
  { value: 'ru', isPostCodeRequired: true },
  { value: 'rw', isPostCodeRequired: false },
  { value: 'sa', isPostCodeRequired: true },
  { value: 'sb', isPostCodeRequired: false },
  { value: 'sc', isPostCodeRequired: false },
  { value: 'sd', isPostCodeRequired: true },
  { value: 'sg', isPostCodeRequired: true },
  { value: 'sh', isPostCodeRequired: true },
  { value: 'sj', isPostCodeRequired: true },
  { value: 'sl', isPostCodeRequired: false },
  { value: 'sm', isPostCodeRequired: true },
  { value: 'sn', isPostCodeRequired: true },
  { value: 'so', isPostCodeRequired: false },
  { value: 'sr', isPostCodeRequired: false },
  { value: 'ss', isPostCodeRequired: false },
  { value: 'st', isPostCodeRequired: false },
  { value: 'sv', isPostCodeRequired: true },
  { value: 'sx', isPostCodeRequired: false },
  { value: 'sy', isPostCodeRequired: false },
  { value: 'sz', isPostCodeRequired: true },
  { value: 'tc', isPostCodeRequired: true },
  { value: 'td', isPostCodeRequired: false },
  { value: 'tf', isPostCodeRequired: true },
  { value: 'tg', isPostCodeRequired: false },
  { value: 'th', isPostCodeRequired: true },
  { value: 'tj', isPostCodeRequired: true },
  { value: 'tk', isPostCodeRequired: false },
  { value: 'tl', isPostCodeRequired: true },
  { value: 'tm', isPostCodeRequired: true },
  { value: 'tn', isPostCodeRequired: true },
  { value: 'to', isPostCodeRequired: false },
  { value: 'tr', isPostCodeRequired: true },
  { value: 'tt', isPostCodeRequired: true },
  { value: 'tv', isPostCodeRequired: false },
  { value: 'tw', isPostCodeRequired: true },
  { value: 'tz', isPostCodeRequired: true },
  { value: 'ua', isPostCodeRequired: true },
  { value: 'ug', isPostCodeRequired: true },
  { value: 'um', isPostCodeRequired: false },
  { value: 'us', isPostCodeRequired: true },
  { value: 'uy', isPostCodeRequired: true },
  { value: 'uz', isPostCodeRequired: true },
  { value: 'va', isPostCodeRequired: true },
  { value: 'vc', isPostCodeRequired: true },
  { value: 've', isPostCodeRequired: true },
  { value: 'vg', isPostCodeRequired: true },
  { value: 'vi', isPostCodeRequired: true },
  { value: 'vn', isPostCodeRequired: true },
  { value: 'vu', isPostCodeRequired: false },
  { value: 'wf', isPostCodeRequired: true },
  { value: 'ws', isPostCodeRequired: true },
  { value: 'xc', isPostCodeRequired: true },
  { value: 'xk', isPostCodeRequired: true },
  { value: 'xl', isPostCodeRequired: true },
  { value: 'ye', isPostCodeRequired: false },
  { value: 'za', isPostCodeRequired: true },
  { value: 'zm', isPostCodeRequired: true },
  { value: 'zw', isPostCodeRequired: false }
]

export const EU_COUNTRIES = [
  'at',
  'ax',
  'be',
  'bg',
  'cy',
  'cz',
  'de',
  'dk',
  'ee',
  'es',
  'fi',
  'fr',
  'gf',
  'gp',
  'gr',
  'hr',
  'hu',
  'ie',
  'it',
  'lt',
  'lu',
  'lv',
  'mc',
  'mf',
  'mq',
  'mt',
  'nl',
  'pl',
  'pt',
  're',
  'ro',
  'se',
  'si',
  'sk',
  'yt'
]

export const ALL_COUNTRIES = [...EU_COUNTRIES, ...NON_EU_COUNTRIES.map(country => country.value)]

export const NON_EU_COUNTRIES_WITHOUT_POSTCODES = NON_EU_COUNTRIES.filter(
  country => !country.isPostCodeRequired
).map(country => country.value)
